import { Navigate } from 'react-router-dom'
import { useProgramContext } from '@/context/ProgramContext'
import { canManageProjectSettings } from '@/lib/programPermissions'

export function AdminManagerGuard({ children }: { children: React.ReactNode }) {
	const { currentProgramAccessLevel } = useProgramContext()

	if (!canManageProjectSettings(currentProgramAccessLevel)) {
		return <Navigate to="/dashboard" replace />
	}

	return <>{children}</>
}
